module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-container', {
    staticClass: "mt-0"
  }, [_c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('h4', [_vm._v("Create a new Investigator")])])], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": "",
      "wrap": "",
      "justify-center": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": "",
      "offset-sm3": ""
    }
  }, [_c('form', {
    attrs: {
      "action": ""
    },
    on: {
      "submit": function($event) {
        $event.preventDefault();
        return _vm.onCreateInvestigator($event)
      }
    }
  }, [_c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-text-field', {
    attrs: {
      "name": "investigatorName",
      "label": "Name",
      "id": "investigatorName",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.investigatorName),
      callback: function($$v) {
        _vm.investigatorName = $$v
      },
      expression: "investigatorName"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "investigatorPhone",
      "label": "Phone Number",
      "id": "investigatorPhone",
      "single-line": ""
    },
    model: {
      value: (_vm.investigatorPhone),
      callback: function($$v) {
        _vm.investigatorPhone = $$v
      },
      expression: "investigatorPhone"
    }
  }), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "name": "investigatorEmail",
      "label": "Email Address",
      "id": "investigatorEmail",
      "single-line": "",
      "required": ""
    },
    model: {
      value: (_vm.investigatorEmail),
      callback: function($$v) {
        _vm.investigatorEmail = $$v
      },
      expression: "investigatorEmail"
    }
  })], 1)], 1), _vm._v(" "), _c('v-layout', {
    attrs: {
      "row": ""
    }
  }, [_c('v-flex', {
    attrs: {
      "xs12": "",
      "sm6": ""
    }
  }, [_c('v-btn', {
    staticClass: "primary",
    attrs: {
      "disabled": !_vm.formIsValid,
      "type": "submit"
    }
  }, [_vm._v("\n              Create Investigator\n            ")])], 1)], 1)], 1)])], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2575da8c","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Investigators/CreateInvestigator.vue
// module id = 665
// module chunks = 1